import type {TableColumn, TableConfig} from '@sms-ir/ui-components';
import type {Contact, EventType} from '../types/contacts.types';

export const CONTACTS_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_MS = 300;

export const ALL_CONTACTS_LABEL = 'همه مخاطبان';

export {ALL_CONTACTS_GROUP_ID} from '../types/contacts.types';

export const CONTACT_TABLE_COLUMNS: TableColumn<Contact>[] = [
  {key: 'select', header: '', customTemplate: true, customHeader: true},
  {key: 'fullName', header: 'نام مخاطب', customTemplate: true},
  {key: 'mobile', header: 'شماره موبایل', customTemplate: true},
  {key: 'groups', header: 'گروه‌ها', customTemplate: true},
  {key: 'events', header: 'رویدادها', customTemplate: true},
  {key: 'actions', header: 'عملیات', customTemplate: true},
];

export const CONTACT_TABLE_CONFIG: TableConfig<Contact> = {
  trackKey: 'id',
  multiSelect: true,
  rowsPerPage: CONTACTS_PAGE_SIZE,
  columnLayout:
    'minmax(0, 48px) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1.2fr) minmax(0, 1fr)',
  mobileLayout: {titleColumn: 'fullName', secondColumn: 'mobile'},
};

export const EVENT_CONTACT_TABLE_COLUMNS: TableColumn<Contact>[] = [
  {key: 'select', header: '', customTemplate: true, customHeader: true},
  {key: 'mobile', header: 'شماره موبایل', customTemplate: true},
  {key: 'fullName', header: 'نام مخاطب', customTemplate: true},
  {key: 'events', header: 'رویدادها', customTemplate: true},
  {key: 'memberEventDate', header: 'تاریخ رویداد', customTemplate: true},
  {key: 'actions', header: 'عملیات', customTemplate: true},
];

export const EVENT_CONTACT_TABLE_CONFIG: TableConfig<Contact> = {
  trackKey: 'id',
  multiSelect: true,
  rowsPerPage: CONTACTS_PAGE_SIZE,
  columnLayout:
    'minmax(0, 48px) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr)',
  mobileLayout: {titleColumn: 'fullName', secondColumn: 'mobile'},
};

export const MEMBER_EVENT_DATE_UNSET_LABEL = 'ثبت نشده';

export const SIDEBAR_ITEM_SIZE = 56;
export const SIDEBAR_VIEWPORT_HEIGHT_PX = 520;
export {GROUP_NAME_MAX_LENGTH_API as GROUP_NAME_MAX_LENGTH} from './contacts-api.constants';
export const EVENT_NAME_MAX_LENGTH = 25;
export const EVENT_TYPE_LOCKED_MESSAGE = 'نوع رویداد پس از ایجاد قابل تغییر نیست';

export const EVENT_TYPE_LABELS: Record<EventType, string> = {
  shared: 'رویداد مشترک',
  individual: 'رویداد فردی',
};

export const IMPORT_MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;
export const IMPORT_ALLOWED_EXTENSIONS = ['csv', 'xlsx', 'txt'] as const;
export const COMING_SOON_MESSAGE = 'عملیات به‌زودی فعال می‌شود.';

export const CONTACTS_MODAL_DEFAULTS = {
  mask: true,
  maskClosable: true,
  keyboard: true,
} as const;

export const EMPTY_GROUP = {
  title: 'لیست مخاطبان گروه خالی است!',
  description: 'برای شروع، اولین مخاطب خود را به این گروه اضافه کنید.',
  cta: 'افزودن مخاطب به گروه',
} as const;

export const EMPTY_NO_GROUPS = {
  title: 'هنوز گروهی ایجاد نشده است',
  description: 'برای مدیریت مخاطبان، ابتدا یک گروه ایجاد کنید.',
  cta: 'ایجاد گروه',
} as const;

export const EMPTY_SEARCH = {
  title: 'مخاطبی با این مشخصات یافت نشد',
  description: 'عبارت جستجو شده در این گروه وجود ندارد.',
  cta: 'پاک کردن جستجو',
} as const;

export const DELETE_GROUP_MESSAGE =
  'این مخاطب از گروه فعلی حذف خواهد شد و از سیستم پاک نمی‌شود.';

export const DELETE_GLOBAL_LABEL = 'حذف مخاطب به صورت کامل';

export const DELETE_ALL_MESSAGE = 'آیا از حذف این مخاطب اطمینان دارید؟ این عمل قابل بازگشت نیست.';

export const EMPTY_NO_EVENTS = {
  title: 'هنوز رویدادی ندارید',
  description:
    'رویدادها به شما کمک می‌کنند مخاطبان را بر اساس تاریخ‌های مهم دسته‌بندی و کمپین‌های هدفمند اجرا کنید.',
  cta: 'ایجاد اولین رویداد',
} as const;


export const EMPTY_SELECT_GROUP = {
  title: 'یک گروه را از پنل سمت راست انتخاب کنید',
  description: 'با انتخاب هر گروه، لیست مخاطبان آن نمایش داده می‌شود.',
} as const;

export const EMPTY_ALL_CONTACTS = {
  title: 'هنوز مخاطبی ثبت نشده است',
  description: 'اولین مخاطب خود را اضافه کنید یا یک گروه برای دسته‌بندی بسازید.',
  cta: 'افزودن مخاطب',
} as const;

export const EMPTY_GROUP_SEARCH = {
  title: 'گروهی یافت نشد',
  description: 'عبارت جستجو شده در گروه‌های مخاطب وجود ندارد.',
} as const;

export const EMPTY_SELECT_EVENT = {
  title: 'یک رویداد را از پنل سمت راست انتخاب کنید',
  description: 'با انتخاب هر رویداد، لیست اعضای آن نمایش داده می‌شود.',
} as const;

export const EMPTY_EVENT_MEMBERS = {
  title: 'هنوز عضوی ندارید',
  description: 'مخاطبانی که می‌خواهید در این رویداد باشند را اضافه کنید.',
  cta: 'افزودن مخاطب',
} as const;

export const EMPTY_EVENT_SEARCH = {
  title: 'مخاطبی با این مشخصات یافت نشد',
  description: 'عبارت جستجو شده در این رویداد وجود ندارد.',
  cta: 'پاک کردن جستجو',
} as const;

export const DELETE_EVENT_MESSAGE =
  'این رویداد و ارتباط تمام اعضای آن حذف خواهد شد. مخاطبان از سیستم پاک نمی‌شوند.';

export const DELETE_EVENT_CONTACT_MESSAGE =
  'این مخاطب از رویداد فعلی حذف خواهد شد و از سیستم پاک نمی‌شود.';
